var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5233 0.770508H2.93481C1.76631 0.770508 0.822266 1.73769 0.822266 2.93483V52.7142C0.822266 53.9114 1.76631 54.8786 2.93481 54.8786H51.5233C52.6918 54.8786 53.6359 53.9114 53.6359 52.7142V2.93483C53.6359 1.73769 52.6918 0.770508 51.5233 0.770508ZM45.4234 16.5633H41.2049C37.8974 16.5633 37.2571 18.173 37.2571 20.5402V25.7549H45.1527L44.1228 33.9185H37.2571V54.8786H29.0247V33.9252H22.1392V25.7549H29.0247V19.7354C29.0247 12.7487 33.1904 8.94083 39.2772 8.94083C42.1951 8.94083 44.6972 9.16402 45.43 9.26547V16.5633H45.4234Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5ff8ede106c1c5e14b833830e63a8bb1.svg";
export { ForwardRef as ReactComponent };